module.exports = __webpack_public_path__ + "static/media/Edit Blue.675db455.svg";